export const formatDate = (d?: string | Date | null): string => {
  if (!d) return '-';
  return new Date(d).toLocaleDateString('pl-PL');
};
